
	if (!customElements.get('car-search')){
		customElements.define(
			'car-search', class CarSearch extends HTMLElement {
				constructor(){
					super()
					this.startSearch = document.getElementById('the-search')
					this.init()
				}
				init(){
					if(this.startSearch.previousElementSibling != null){
						if(this.startSearch.previousElementSibling.name == 'engine'){
							
						}
					}
				}
			}
		)
	}

	if (!customElements.get('year-search')) {
		customElements.define('year-search', class YearSearch extends HTMLElement {

			constructor(){
				super()

				this.urlPath = ''
				this.makeDone = ''
				this.ModelDone = ''
				this.SubModelDone = ''
				this.engineDone = ''
				this.engineFinal = ''

				this.year = this.querySelector('.select-year-parts')
				this.make = this.querySelector('.select-make-parts')
				this.model = this.querySelector('.select-model-parts')
				this.submodel = this.querySelector('.select-sub-model-parts')
				this.engine = this.querySelector('.select-engine-parts')

				
				if( this.make != null ){
					this.year.addEventListener('change', this.getMake.bind(this))
					this.make.addEventListener('change', this.getModel.bind(this))
				}else{
					this.year.addEventListener('change', this.getModel.bind(this))
				}

				this.model.addEventListener('change', this.getSubModel.bind(this))
				this.submodel.addEventListener('change', this.getEng.bind(this))
				this.engine.addEventListener('change', this.finalEng.bind(this))
				
				
				this.formId = document.getElementById('the-forid')
				this.initYearSearch()
			}

			getMake(evt){
				let selectVal = this.year.options[this.year.selectedIndex].value
				if( selectVal == 'select'){
					this.make.disabled = true
					this.model.disabled = true
					this.submodel.disabled = true
					this.engine.disabled = true
				}else{

					this.model.disabled = true
					this.submodel.disabled = true
					this.engine.disabled = true
					this.makeDone = selectVal
					this.urlPath = `/collections/all?filter.p.m.year_n.year_k=${selectVal}`
					this.formId.setAttribute("href", this.urlPath)
					axios.get(`/collections/all?filter.p.m.year_n.year_k=${selectVal}&view=ajax`)
					.then(
						response => {
							let parser = new DOMParser();
							const dataParce = parser.parseFromString(response.data, 'text/html')
							const dataParceTarget = dataParce.querySelector('.select-make-parts-result')

							let newMakeA = []
							for (var i=0, n=dataParceTarget.options.length; i<n; i++) {
								if (dataParceTarget.options[i].value) newMakeA.push(dataParceTarget.options[i].value);
							}
							let uniqueArray = newMakeA.filter(function(item, pos, self) {
								return self.indexOf(item) == pos;
							})
							var newMake = '<option value="' + 'select' + '">' + 'select' + '</option>'
							uniqueArray.forEach(
								option => {
									newMake += '<option value="' + option + '">' + option + '</option>';
								}
							)
							this.make.innerHTML = newMake
							this.make.disabled = false
						}
					)
					.catch(function (error) {
						console.log(error)
					})
					.finally(() => {
						// you finaly code here
					})


				}
			}

			getModel(evt){

				let selectValue = ''
				if( this.make != null ){
					selectValue = this.make.options[this.make.selectedIndex].value
				}else{
					selectValue = this.year.options[this.year.selectedIndex].value
				}

				if( selectValue == 'select'){
					this.model.disabled = true
					this.submodel.disabled = true
					this.engine.disabled = true
				}else{
					this.submodel.disabled = true
					this.engine.disabled = true

					if( this.make != null ){
						this.urlPath = `/collections/all?filter.p.m.make_n.make_k=${selectValue}&filter.p.m.year_n.year_k=${this.makeDone}`
						this.ModelDone = selectValue
					}else{
						this.urlPath = `/collections/all?filter.p.m.year_n.year_k=${selectValue}`
						this.makeDone = selectValue
					}
					

					this.formId.setAttribute("href", this.urlPath)

					axios.get(`${this.urlPath}&view=ajax`)
					.then(
						response => {
							let parser = new DOMParser();
							const data = parser.parseFromString(response.data, 'text/html')
							const dataParceTarget = data.querySelector('.select-model-parts-result')
							
							let newModel = []
							for (var i=0, n=dataParceTarget.options.length; i<n; i++) {
								if (dataParceTarget.options[i].value) newModel.push(dataParceTarget.options[i].value);
							}
							let uniqueArray = newModel.filter(function(item, pos, self) {
								return self.indexOf(item) == pos;
							})
							var newModelRen = '<option value="' + 'select' + '">' + 'select' + '</option>'
							uniqueArray.forEach(
								option => {
									newModelRen += '<option value="' + option + '">' + option + '</option>';
								}
							)

							this.model.innerHTML = newModelRen
							this.model.disabled = false

						}
					)
					.catch(function (error) {
						console.log(error)
					})
					.finally(() => {
						// you finaly code here
					})
				}
				
			}

			getSubModel(evt){
				let selectModel = this.model.options[this.model.selectedIndex].value

				if( selectModel == 'select'){
					this.submodel.disabled = true
					this.engine.disabled = true
				}else{
					this.SubModelDone = selectModel


					if( this.make != null ){
						this.urlPath = `/collections/all?filter.p.m.make_n.make_k=${this.ModelDone}&filter.p.m.model_n.model_k=${selectModel}&filter.p.m.year_n.year_k=${this.makeDone}`
					}else{
						this.urlPath = `/collections/all?&filter.p.m.model_n.model_k=${selectModel}&filter.p.m.year_n.year_k=${this.makeDone}`
					}
					
					
					this.formId.setAttribute("href", this.urlPath)
					axios.get(`${this.urlPath}&view=ajax`)
					.then(
						response => {
							let parser = new DOMParser();
							const data = parser.parseFromString(response.data, 'text/html')

							// class name
							const dataParceTarget = data.querySelector('.select-sub-model-parts-result')
							
							let subNewModel = []
							for (var i=0, n=dataParceTarget.options.length; i<n; i++) {
								if (dataParceTarget.options[i].value) subNewModel.push(dataParceTarget.options[i].value);
							}
							let uniqueArray = subNewModel.filter(function(item, pos, self) {
								return self.indexOf(item) == pos;
							})
							var subNewModelRe = '<option value="' + 'select' + '">' + 'select' + '</option>'
							uniqueArray.forEach(
								option => {
									subNewModelRe += '<option value="' + option + '">' + option + '</option>';
								}
							)
							this.submodel.innerHTML = subNewModelRe
							this.submodel.disabled = false

							// class name
							const dataEng = data.querySelector('.select-engine-parts-result')

							let newEng = []
							for (var i=0, n=dataEng.options.length; i<n; i++) {
								if (dataEng.options[i].value) newEng.push(dataEng.options[i].value);
							}
							let uniqueEng = newEng.filter(function(item, pos, self) {
								return self.indexOf(item) == pos;
							})
							var uniqueEngSelect = '<option value="' + 'select' + '">' + 'select' + '</option>'
							uniqueEng.forEach(
								option => {
									uniqueEngSelect += '<option value="' + option + '">' + option + '</option>';
								}
							)
							this.engine.innerHTML = uniqueEngSelect
							this.engine.disabled = false

						}
					)
					.catch(function (error) {
						console.log(error)
					})
					.finally(() => {
						// you finaly code here
					})
				}
			}

			getEng(evt){
				
				let selectEng = this.submodel.options[this.submodel.selectedIndex].value

				if( selectEng != 'select'){
					this.engineDone = selectEng
					
					this.urlPath = `/collections/all?filter.p.m.make_n.make_k=${this.ModelDone}&filter.p.m.model_n.model_k=${this.SubModelDone}&filter.p.m.sub_model_n.sub_model_k=${selectEng}&filter.p.m.year_n.year_k=${this.makeDone}`

					this.formId.setAttribute("href", this.urlPath)
					axios.get(`${this.urlPath}&view=ajax`)
					.then(
						response => {
							let parser = new DOMParser();
							const data = parser.parseFromString(response.data, 'text/html')
							const dataEng = data.querySelector('.select-engine-parts-result')

							let newEng= []
							for (var i=0, n=dataEng.options.length; i<n; i++) {
								if (dataEng.options[i].value) newEng.push(dataEng.options[i].value);
							}
							let uniqueEng = newEng.filter(function(item, pos, self) {
								return self.indexOf(item) == pos;
							})
							var newEngS = '<option value="' + 'select' + '">' + 'select' + '</option>'
							uniqueEng.forEach(
								option => {
									newEngS += '<option value="' + option + '">' + option + '</option>';
								}
							)
							this.engine.innerHTML = newEngS
						}
					)
					.catch(function (error) {
						console.log(error)
					})
					.finally(() => {
						// you finaly code here
					})
				}

				if( selectEng == 'select'){
					this.getSubModel()
				}
			}

			finalEng(evt){
				evt.preventDefault()
				let selectVal = this.engine.options[this.engine.selectedIndex].value
				if( selectVal != 'select'){
				}
			}

			initYearSearch(){
				axios.get(`/collections/all?view=ajax`)
				.then(
					response => {
						let parser = new DOMParser();
						const dataParce = parser.parseFromString(response.data, 'text/html')
						const dataParceTarget = dataParce.querySelector('.select-year-parts-result')
						let newYear = []

						for (var i=0, n=dataParceTarget.options.length; i<n; i++) {
							if (dataParceTarget.options[i].value) newYear.push(dataParceTarget.options[i].value);
						}
						
						let uniqueArray = newYear.filter(function(item, pos, self) {
							return self.indexOf(item) == pos;
						})

						var newYearOp = '<option value="' + 'select' + '">' + 'select' + '</option>'
						uniqueArray.forEach(
							option => {
								newYearOp += '<option value="' + option + '">' + option + '</option>';
							}
						)
						this.year.innerHTML = newYearOp

					}
				)
				.catch(function (error) {
					console.log(error)
				})
				.finally(() => {
					// you finaly code here
				})
			}

		})
	}
	